import {
  PlusCircle,
  FilePlus,
  Ticket,
  Tag,
  Store,
  UserPlus,
  Banknote,
  KeyRound,
  Mail,
  BellRing,
  Lock,
  LogOut,
} from 'lucide-react';
import type { ActionEntry } from './types';

// Event dispatched when the user picks "Create new store" from the palette.
// Navigation.js listens for this and opens the create-store dialog.
export const CREATE_STORE_EVENT = 'command-palette:open-create-store';

// Actions do NOT duplicate nav destinations. "Go to Payments" etc. are dropped —
// users find those via the Navigation group after typing, and the sidebar.
// Keep actions for things that *do* something (create, invite, log out) or go
// to sub-pages that aren't in the sidebar (billing, account, API keys).
export const actionEntries: ActionEntry[] = [
  {
    id: 'action-create-checkout-page',
    label: 'Create checkout page',
    icon: PlusCircle,
    keywords: ['new', 'page'],
    run: ctx => ctx.history.push('/checkouts/new'),
  },
  {
    id: 'action-create-form',
    label: 'Create form',
    icon: FilePlus,
    keywords: ['new'],
    run: ctx => ctx.history.push('/forms/new'),
  },
  {
    id: 'action-create-event',
    label: 'Create event',
    icon: Ticket,
    keywords: ['new', 'ticket'],
    run: ctx => ctx.history.push('/events/new'),
  },
  {
    id: 'action-create-coupon',
    label: 'Create coupon',
    icon: Tag,
    keywords: ['new', 'discount', 'promo'],
    run: ctx => ctx.history.push('/coupons/new'),
  },
  {
    id: 'action-create-store',
    label: 'Create new store',
    icon: Store,
    keywords: ['new', 'workspace', 'account'],
    run: () => window.dispatchEvent(new CustomEvent(CREATE_STORE_EVENT)),
  },
  {
    id: 'action-invite-team',
    label: 'Invite team member',
    icon: UserPlus,
    keywords: ['teammate', 'user'],
    run: ctx => ctx.history.push('/settings/members'),
  },
  {
    id: 'action-manage-billing',
    label: 'Manage billing',
    icon: Banknote,
    keywords: ['invoice', 'subscription'],
    run: ctx => ctx.history.push('/settings/billing'),
  },
  {
    id: 'action-view-api-keys',
    label: 'View API keys',
    icon: KeyRound,
    keywords: ['developer', 'token'],
    run: ctx => ctx.history.push('/settings/api'),
  },
  {
    id: 'action-change-email',
    label: 'Change email',
    icon: Mail,
    keywords: ['account', 'profile'],
    run: ctx => ctx.history.push('/account/profile'),
  },
  {
    id: 'action-change-password',
    label: 'Change password',
    icon: Lock,
    keywords: ['account', 'profile', 'security'],
    run: ctx => ctx.history.push('/account/profile'),
  },
  {
    id: 'action-email-notifications',
    label: 'Email notifications',
    icon: BellRing,
    keywords: ['account', 'preferences', 'unsubscribe'],
    run: ctx => ctx.history.push('/account/emails'),
  },
  {
    id: 'action-logout',
    label: 'Log out',
    icon: LogOut,
    keywords: ['sign out', 'logout'],
    hideFromSuggested: true,
    run: ctx => ctx.logout(),
  },
];
